import instance from "config/interceptor";

export const mutateDownloadAbsensi = async (params: any) => {
  return await instance.post(`Delivery/DownloadReportAbsensi`, params, {
    responseType: 'blob',
  });
};